<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { ReportEditorViewModel } from '@Reports/Reports/Components/ReportEditor'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: ReportEditorViewModel
    }>()

    const emit = defineEmits<{
        (e: 'update-report', payload: unknown): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const isSaving = computed(() => vm.value.isSaving)
    const d = computed(() => vm.value.data)
    const nameError = computed(() => vm.value.reportNameError)

    // ---------------- actions ----------------

    function onFormSubmit()
    {
        vm.value.clearValidationErrors()
        vm.value.isSaving = true

        emit('update-report', vm.value.data)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit report</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="report-editor-form" @submit.prevent="onFormSubmit">
                            <div class="form-group">
                                <label>Report name:</label>
                                <input type="text" v-model.trim="d.Name" class="form-control" required maxlength="100" minlength="2">
                                <small class="text-danger">{{nameError}}</small>
                            </div>
                            <div class="form-group">
                                <label>Description (optional):</label>
                                <textarea v-model.trim="d.Description" class="form-control" rows="5" maxlength="250"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">

                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="report-editor-form" :disabled="isSaving" class="btn btn-primary">
                            <span v-if="isSaving"><i class="fa fa-spinner fa-spin"></i> Please wait...</span>
                            <span v-if="!isSaving">Update</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>